import {Repository, createRepository} from '@/repositories/Base/Repository'

class TriggerRepository extends Repository {
    endpoint = 'vam/trigger'

    listActions(params) {
        return this.$axios.get(`${this.endpoint}/actions`, params)
    }

}

export default new TriggerRepository()

export const create = createRepository(TriggerRepository)

